import { Crop, SlidersHorizontal, Palette } from 'lucide-react';
import type { EditorTab } from './imageEditorTypes';
import { useTranslation } from '../../i18n';
import styles from './ImageEditor.module.css';

interface ImageEditorToolbarProps {
  activeTab: EditorTab;
  onTabChange: (tab: EditorTab) => void;
  children: React.ReactNode;
}

const TABS: { key: EditorTab; icon: typeof Crop; labelKey: string }[] = [
  { key: 'crop', icon: Crop, labelKey: 'imageEditor.tabCrop' },
  { key: 'adjust', icon: SlidersHorizontal, labelKey: 'imageEditor.tabAdjust' },
  { key: 'filter', icon: Palette, labelKey: 'imageEditor.tabFilter' },
];

export function ImageEditorToolbar({ activeTab, onTabChange, children }: ImageEditorToolbarProps) {
  const { t } = useTranslation();

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.tabNav}>
        {TABS.map(({ key, icon: Icon, labelKey }) => (
          <button
            key={key}
            type="button"
            className={`${styles.tabBtn} ${activeTab === key ? styles.tabBtnActive : ''}`}
            onClick={() => onTabChange(key)}
            title={t(labelKey as Parameters<typeof t>[0])}
          >
            <Icon size={18} />
            <span className={styles.tabLabel}>
              {t(labelKey as Parameters<typeof t>[0])}
            </span>
          </button>
        ))}
      </nav>
      <div className={styles.tabBody}>
        {children}
      </div>
    </aside>
  );
}
